import axios from 'axios'
import { CountItemsResponse } from '@/modules/index-monitoring-module/services/scientific-analysis-admin-module.dto'

class ScientificAnalysisAdminModuleService {
    async getScientificAnalysisAdminCount(): Promise<CountItemsResponse[]> {
        const response = await axios.get<CountItemsResponse[]>(`/scientificAnalysis/admin/count`)
        return response.data
    }
}

export const scientificAnalysisAdminModuleService = new ScientificAnalysisAdminModuleService()
